import React from "react";
import { Typography, Box } from "@mui/material";
import { Controller } from "react-hook-form";
import { BondNumberSelect } from "../Helpers/BondNumberSelect";
import PropTypes from "prop-types";

const BlanketHistoricBondNumberSection = ({ control, setValue, errors }) => (
  <Box className="grid grid-cols-1 gap-4">
    <Typography variant="h5" className="font-bold mb-4">
      Bond Number
    </Typography>
    <Controller
      name="bond_number"
      control={control}
      defaultValue={null}
      rules={{ required: "Bond Number is required" }}
      render={({ field }) => (
        <Box>
          <BondNumberSelect
            data={{ bond_number: field.value }}
            updateData={(next) => {
              // next: { bond_number: selectedOption }
              field.onChange(next?.bond_number || null);
              setValue("bond_number", next?.bond_number || null, { shouldValidate: true });
            }}
          />
          {errors?.bond_number && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {errors?.bond_number?.message || "Bond Number is required"}
            </Typography>
          )}
        </Box>
      )}
    />
  </Box>
);

BlanketHistoricBondNumberSection.propTypes = {
  control: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
  errors: PropTypes.object,
};

export default BlanketHistoricBondNumberSection;
